export function jsonStringify(data) {
    return JSON.stringify(data);
}
//# sourceMappingURL=json.js.map